import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qkjzzyp79p: FaireBrandEntity = {
  token: "b_qkjzzyp79p",
  type: "brand",
  name: "Nose Dive",
  avatarUrl:
    "https://cdn.faire.com/fastly/d5a1b8598f19032aa53bae32104501efa3253b52bef900651d79e992b4eac470.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/07bb80e79cd1354b2809415e9583924fded8d4f583433e39fcb7d6553bd3564a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d5a1b8598f19032aa53bae32104501efa3253b52bef900651d79e992b4eac470.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/07bb80e79cd1354b2809415e9583924fded8d4f583433e39fcb7d6553bd3564a.jpeg",
  location: "Minneapolis, MN, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 14,
  isInsider: true,
  description:
    "Nose Dive was created with the belief that scent is more than fragrance—it’s memory, mood, and ritual wrapped into one. Each candle is designed to capture a fleeting moment and make it last a little longer: the ease of slipping into a baggy sweatshirt, the glow of a late checkout morning, the warmth of a nightcap shared with friends. By pairing thoughtful design with complex, layered fragrance notes, we craft pieces that don’t just sit in your space—they set the tone for it.\n\nOur approach is rooted in storytelling. We don’t chase trends or seasonal gimmicks—we create olfactive worlds that feel oddly familiar yet refreshingly new. Every vessel, every name, and every burn is about sparking connection: between you and your home, between scent and memory, between ritual and joy. Nose Dive isn’t just about lighting a candle; it’s about leaning into the moments that make life textured, playful, and deeply human.",
  meta: {
    source: "api",
    importedAt: "2026-09-17T19:49:28.029Z",
    importedBy: "entity-db-cli",
  },
};
